export default __webpack_public_path__ + "static/media/coupon.dbaaaa30.svg";